import * as e from "react";
import { forwardRef as o } from "react";
const m = o(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.67773 15.6269C6.68102 18.8507 11.102 21 11.102 21C11.102 21 10.1451 18.9344 10.1586 17.5075C10.1761 15.6753 11.8095 13.209 11.8095 13.209C11.8095 13.209 13.3823 15.6773 13.4604 17.5075C13.52 18.9056 12.7528 21 12.7528 21C12.7528 21 18.106 18.0448 18.4129 15.6269C18.7199 13.209 14.4037 7.83582 14.4037 7.83582C14.4037 7.83582 14.8372 10.6891 14.4037 12.403C13.4425 16.2033 11.102 3 11.102 3C11.102 3 4.67445 12.403 5.67773 15.6269Z",
        fill: "#FFCF54"
      }
    )
  );
});
export {
  m as Flame
};
